// extracted by mini-css-extract-plugin
module.exports = {"input":"ca812","wrapper":"ffb10","error":"ea057"};